import React from "react";
import { Resource } from "../../../modules/academy/models";

export interface ResourceCardProps extends Resource {}

export function ResourceCard({ title, type, audience, duration }: ResourceCardProps) {
  const typeLabel = `Type: ${type}`;
  const audienceLabel = audience ? `Audience: ${audience}` : "Audience: generale";
  return (
    <div className="mm-surface p-4 space-y-2">
      <h3 className="text-base font-semibold">{title}</h3>
      <p className="text-xs text-slate-500 dark:text-slate-400">
        {typeLabel} · {audienceLabel} · {duration ? `${duration} min` : "Temps libre"}
      </p>
      <button
        type="button"
        className="px-3 py-1.5 rounded-lg bg-white border text-sm font-semibold hover:bg-slate-50 dark:bg-slate-900 dark:border-slate-700"
      >
        Voir la ressource
      </button>
    </div>
  );
}
